import React from 'react'
import tw from 'tailwind-styled-components'
import {Sync} from '@client/sync'
import {Badge, BadgeProps} from '@components/common/base/badge'
import {IconButton} from '@components/common/base/buttons'
import {withUpdaters} from '@containers/updaters'
import {SyncUpdater} from '@containers/updaters/sync-updater'
import {ChatUtils} from '@extensions/chat-utils'

const TwWrapper = tw.div`
  absolute
  top-12
  -left-[33px]
  w-32
  h-32
  z-40
`

const TwButton = tw(IconButton)`
  w-[33px]
  h-32
  p-8
  rounded-tl-8
  rounded-bl-8
  bg-panel-background-active
  !text-panel-text-secondary
`

const TwBadge = tw<BadgeProps & {$visible?: boolean}>(Badge)`
  absolute
  -top-4
  -left-4
  pointer-events-none
  duration-75
  transition-opacity
  ${p => (p.$visible ? 'opacity-100 delay-200' : 'opacity-0')}
`

export interface MinimizeButtonProps {
  minimized: boolean
  onClick: () => void
}

interface MinimizeButtonBaseProps extends MinimizeButtonProps {
  newMessages: number
}

const MinimizeButtonBase = ({
  minimized,
  newMessages,
  onClick
}: MinimizeButtonBaseProps) => (
  <TwWrapper>
    <TwButton
      onClick={onClick}
      icon={minimized ? 'IconMessages' : 'IconCustomArrowBarRight'}
      size="small"
      color="grey"
    />
    <TwBadge type="rounded" unread $visible={minimized && !!newMessages}>
      {newMessages > 99 ? '99+' : newMessages}
    </TwBadge>
  </TwWrapper>
)

export const MinimizeButton = withUpdaters(
  SyncUpdater({companyType: 'current', filter: '*', debounceTime: 1000}),
  SyncUpdater({companyType: 'profile', filter: '*', debounceTime: 1000})
)((props: MinimizeButtonProps) => {
  const box = Sync.getCurrentSandbox()
  const newMessages = props.minimized
    ? ChatUtils.newMessagesFromAllTaskChats(box, 'withCurrentUser') +
      ChatUtils.newMessagesFromAllGroupChats(box, undefined, true) +
      ChatUtils.newMessagesFromAllPersonalChats()
    : 0
  return <MinimizeButtonBase {...props} newMessages={newMessages} />
})
